<template>
<div class="vx-row">
    <div class="vx-col w-full mb-base">
        <vx-card class="mb-5">
            <vs-row vs-w="12" class="mb-5">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
                    <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
                    <h3>View Campaign</h3>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
                    <!-- <vs-button v-if="abilities.can('update', 'campaigns')" @click="editCompany" icon="edit" color="danger"
              type="border">Edit</vs-button> -->
                </vs-col>
            </vs-row>
            <vs-divider class="m-5" />
            <div class="vx-row p-5">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Opportunities/Meetings:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    <vs-button color="primary" @click="showOpportunityDocs" type="filled">Download</vs-button>
                </div>
            </div>

            <div class="vx-row p-5" v-if="campaignDescription.campaign_name">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Campaign Name:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    {{ campaignDescription.campaign_name }}
                </div>
            </div>
            <div class="vx-row p-5" v-if="campaignDescription.campaign_code">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Campaign Code:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    {{ campaignDescription.campaign_code }}
                </div>
            </div>

            <div v-if="campaignDescription.clients">
                <div class="vx-row p-5">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>
                            Client:
                        </span>
                    </div>
                    <template v-for="client in campaignDescription.clients">
                        <div class="vx-col">

                            <span class="mt-5">
                                {{ client.client_name }}
                                <span v-if="client.primary_contact_id == primary_client">Ⓟ</span>
                            </span>

                            <br>
                            <span class="mt-10 mr-5">Primary Contact :
                                {{ client.primary_contact_name }}</span>

                            <div v-if="campaignDescription.other_client_user_campaign_association">
                                <span>
                                    Other Client Contact:
                                </span>
                                <template v-for="client_contact in campaignDescription.other_client_user_campaign_association">

                                    <span v-if="client.client_id == client_contact.client_id" class="mt-5 ml-5">{{
                      client_contact.first_name
                    }} {{ client_contact.surname }}</span>

                                </template>
                            </div>

                        </div>

                    </template>
                </div>
            </div>

            <div class="vx-row p-5" v-if="campaignDescription.campaign_manager">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Campaign Manager:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    {{ campaignManager }}
                </div>
            </div>
            <div class="vx-row p-5" v-if="campaignDescription.start_date">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Start Date:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    {{ campaignDescription.start_date }}
                </div>
            </div>
            <div class="vx-row p-5" v-if="campaignDescription.end_date">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        End Date:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    {{ campaignDescription.end_date }}
                </div>
            </div>
            <div class="vx-row p-5" v-if="campaignDescription.setup">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Setup:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    {{ campaignDescription.setup }}
                </div>
            </div>
            <div class="vx-row p-5" v-if="campaignDescription.target_pipeline">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Target Pipeline:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    {{ campaignDescription.target_pipeline }}
                </div>
            </div>

            <template v-for="pos in campaignDescription.campaign_pos">

                <div class="vx-row p-5">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>
                            PO :
                        </span>
                    </div>

                    <div class="vx-col">

                        <span class="mt-10 mr-5">PO Number :
                            <strong></strong> {{ pos.po_number }}</span>

                        <div>
                            <span>
                                PO Value Allocated to Campaign:
                            </span>

                            <span class="mt-10 ml-5">{{
                  pos.campaign_po_value_allocated
                }}</span>

                        </div>

                    </div>

                </div>

            </template>

            <div class="vx-row p-5" v-if="campaignDescription.daily_rate">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Daily Rate:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    {{ campaignDescription.daily_rate }}
                </div>
            </div>
            <div class="vx-row p-5" v-if="campaignDescription.target_no_of_opportunities">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Target Number of Opportunities:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    {{ campaignDescription.target_no_of_opportunities }}
                </div>
            </div>
            <div class="vx-row p-5" v-if="campaignDescription.target_no_of_vacs">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Target Number of VACs:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    {{ campaignDescription.target_no_of_vacs }}
                </div>
            </div>
            <div class="vx-row p-5">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Opportunity Owner:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    {{ campaignDescription.alert_opportunity_owner }}
                </div>
            </div>
            <div class="vx-row p-5">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Sales Developers:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">

                    <template v-for="sd in campaignDescription.sales_developers">
                        {{ sd.first_name + " " + sd.surname }}
                        <br>
                       

                    </template>

                </div>
            </div>

             <div class="vx-row p-5" v-if="sd_allocation_summary">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        SD Time Allocation:
                    </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                                        <span v-if="sd_allocation_summary.no_sd_required">
                        No Sales Developer required (exempt from allocation).
                    </span>
                    <span v-else-if="sd_allocation_summary.allocation_exempt">
                        Internal campaign &mdash; SD time is not allocated or tracked.
                    </span>
                    <template v-else>
                        <span>
                            Budget: <b>{{ sd_allocation_summary.budget_days }}</b> days
                            <span class="ml-5">Allocated: <b>{{ sd_allocation_summary.allocated_days }}</b> days</span>
                            <span class="ml-5">Unallocated: <b>{{ sd_allocation_summary.unallocated_days }}</b> days</span>
                        </span>
                        <vs-table class="mt-5" v-if="sd_allocation_summary.sales_developers && sd_allocation_summary.sales_developers.length"
                            :data="sd_allocation_summary.sales_developers">
                            <template slot="thead">
                                <vs-th>Sales Developer</vs-th>
                                <vs-th>Allocated</vs-th>
                                <vs-th>Used</vs-th>
                                <vs-th>Remaining</vs-th>
                            </template>
                            <template slot-scope="{ data }">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td>{{ data[indextr].full_name }}</vs-td>
                                    <vs-td>{{ data[indextr].allocated_hours == null ? 'Not allocated'
                                        : data[indextr].allocated_hours + ' h (' + data[indextr].allocated_days + ' d)' }}</vs-td>
                                    <vs-td>{{ data[indextr].used_hours + ' h' }}</vs-td>
                                    <vs-td>{{ data[indextr].remaining_hours == null ? '&mdash;'
                                        : data[indextr].remaining_hours + ' h (' + data[indextr].remaining_days + ' d)' }}</vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </template>

                     <div class="vx-row p-5" v-if="sd_allocation_summary && !sd_allocation_summary.no_sd_required && !sd_allocation_summary.allocation_exempt">
                    <SdAllocationHistory :campaign-id="$route.params.campaignId" />
            </div>
                </div>
                
            </div>
           
          
            <div class="vx-row p-5" v-if="campaignDescription.campaign_status">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Status:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    {{ campaignStatus }}
                </div>
            </div>
            <div class="vx-row p-5" v-if="campaignDescription.briefing_document">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        Briefing Document:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    <vs-button @click="
              downloadBriefingWithAxios(campaignDescription.briefing_document)
              " color="danger" type="border">Download</vs-button>
                </div>
            </div>
            <div class="vx-row p-5" v-if="campaignDescription.end_of_campaign_report">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>
                        End Of Campaign Report:
                    </span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                    <vs-button @click="
              downloadEOCRWithAxios(
                campaignDescription.end_of_campaign_report
              )
              " color="danger" type="border">Download</vs-button>
                </div>
            </div>

            <div v-if="campaignDescription.campaign_client_dashboard">
                <div class="vx-row p-5">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>
                            Client Dashboard:
                        </span>
                    </div>
                    <template v-for="client_dashboard in campaignDescription.campaign_client_dashboard">
                        {{ client_dashboard.name }} {{ ' ( ' + client_dashboard.client_dashboard_name + ')' }}
                        <br>
                        <template v-for="permission in client_dashboard.permission">
                            {{ permission.first_name }} {{ permission.surname }}
                            <br>
                        </template>
                        <br><br>

                    </template>
                </div>
            </div>
            <div v-if="campaignDescription.selected_docs_template">
                <div class="vx-row p-5">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>
                            Docs Template:
                        </span>
                    </div>
                    {{ campaignDescription.selected_docs_template.name }}

                </div>
            </div>
            <div v-if="campaignDescription.selected_email_template">
                <div class="vx-row p-5">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>
                            Email Template:
                        </span>
                    </div>
                    {{ campaignDescription.selected_email_template.name }}

                </div>
            </div>
            <div v-if="campaignDescription.alert_recipients">
                <div class="vx-row p-5">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>
                            Alert Recipients:
                        </span>
                    </div>

                    <template v-for="ar in campaignDescription.alert_recipients">
                        {{ ar.first_name }} {{ ar.surname }}
                        <br>
                    </template>
                </div>
            </div>
            <div v-if="campaignDescription.user_campaign_association">
                <div class="vx-row p-5">
                    <div class="vx-col sm:w-1/5 w-full">
                        <span>
                            Elomark Users:
                        </span>
                    </div>
                    <template v-for="elomark_user in campaignDescription.user_campaign_association">
                        {{ elomark_user.first_name + " " + elomark_user.surname }}
                        <br />
                    </template>
                </div>
            </div>
        </vx-card>
    </div>
    <vs-popup fullscreen title="Opportunity Documents" :active.sync="showOpportunityDocsPopup">
        <div class="vx-row mb-8">
            <div class="vx-col sm:w-1/6 w-full">
                <span>Search :</span>
            </div>
            <div class="vx-col sm:w-1/4 w-full">
                <vs-input type="text" class="w-full" name="opportunity_docs_search_filter" v-model="opportunity_docs_search_filter" @keyup="opportunityDocsUpdatePaginate" />
            </div>

        </div>
        <div class="vx-row mb-8">
            <div class="vx-col sm:w-1/6 w-full">
                <span> </span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">

                <div class="vx-row mb-6 all_opportunity_docs_rows" v-for="docs, index in filterBy(opportunity_docs_lists, opportunity_docs_search_filter, 'name')" v-show="opportunityDocsSetPaginate(index)">
                    <div class="vx-col w-full">

                        <div class="vx-row mb-1">
                            <div class="vx-col sm:w-1/2 w-full">

                                <div class="vx-row">
                                    <div class="vx-col sm:w-1/8">
                                        <template v-if="user_role != 'Client' && user_role != 'Client Administrator'">
                                                                                    <feather-icon icon="XIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-5 mb-5" @click.stop="deleteData(docs.id)" />

                                            </template>
                                    </div>
                                    <div class="vx-col">

                                        <span>{{ docs.name }}</span>

                                    </div>
                        
                                </div>


                            </div>
                            <div class="vx-col sm:w-1/6 w-full">
                                <vs-checkbox v-model="selected_opportunity_docs" :vs-value="docs"></vs-checkbox>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
        <!-- <div class="vx-row mb-8">
            <div class="vx-col sm:w-1/6 w-full">
                <span> </span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">

                <div class="vx-row mb-6 all_opportunity_docs_rows" v-for="docs, index in filterBy(opportunity_docs_lists, opportunity_docs_search_filter, 'name')" v-show="opportunityDocsSetPaginate(index)">
                    <div class="vx-col w-full">

                        <div class="vx-row mb-1">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>{{ docs.name }}</span>
                            </div>
                            <div class="vx-col sm:w-1/5 w-full">
                                <vs-checkbox v-model="selected_opportunity_docs" :vs-value="docs"></vs-checkbox>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div> -->
        <div class="vx-row mb-8">
            <div class="vx-col sm:w-1/6 w-full">
                <span> </span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">

                <div class="pagination mb-5">
                    <a href="#" class="btn btn-default" v-for="page_index in opportunity_docs_paginate_total" @click.prevent="opportunityDocsUpdateCurrent(page_index)">
                        {{ page_index }}
                    </a>
                </div>
            </div>

        </div>

        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
                <vs-button class="mr-3 mb-2" @click.prevent="downloadOpportunityDocs">Download</vs-button>
            </div>
        </div>

    </vs-popup>
</div>
</template>

<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import axios from "@/axios.js";
import _ from "lodash";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleElomarkUsersManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import moduleClientUsersManagement from "@/store/client-user-management/moduleClientUserManagement.js";
import vSelect from "vue-select";
import SdAllocationHistory from "./SdAllocationHistory.vue";
import Vue2Filters from 'vue2-filters'
import {
    saveAs
} from 'file-saver';
export default {
    mixins: [Vue2Filters.mixin],
    data() {
        return {
            authorized: true,
            user_id: null,
            user_role: null,
            selected_opportunity_docs: [],

            opportunity_docs_lists: [],

            opportunity_docs_current: 1,
            opportunity_docs_paginate: 10,
            opportunity_docs_paginate_total: 0,
            opportunity_docs_search_filter: '',
            showOpportunityDocsPopup: false,

            primary_client: null,
            abilities: null,

            campaignDescription: [],
            sd_allocation_summary: null,
            campaignManager: null,
            campaignStatus: null,
            clientName: null,
            prevClientContact: null,
            salesDeveloper1: null,
            salesDeveloper2: null,
            salesDeveloper3: null
        };
    },
    components: {
        "v-select": vSelect,
        SdAllocationHistory
    },
    created() {

        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.user_id = userInfo["uid"];
        this.user_role = userInfo["userRole"];
        var self = this
        defineAbilitiesFor().then(function (data) {
            self.abilities = data
        });
        if (!moduleCampaignsManagement.isRegistered) {
            this.$store.registerModule(
                "campaignsManagement",
                moduleCampaignsManagement
            );
            moduleCampaignsManagement.isRegistered = true;
        }
        if (!moduleElomarkUsersManagement.isRegistered) {
            this.$store.registerModule(
                "elomarkUsersManagement",
                moduleElomarkUsersManagement
            );
            moduleElomarkUsersManagement.isRegistered = true;
        }
        if (!moduleClientManagement.isRegistered) {
            this.$store.registerModule("clientsManagement", moduleClientManagement);
            moduleClientManagement.isRegistered = true;
        }
        if (!moduleClientUsersManagement.isRegistered) {
            this.$store.registerModule(
                "clientUsersManagement",
                moduleClientUsersManagement
            );
            moduleClientUsersManagement.isRegistered = true;
        }

        this.checkClientUserCampaignPermission()

    },
    mounted() {
        if (this.authorized) {
            this.init();
            this.fetchSdAllocationSummary();
        }

    },
    methods: {
        deleteData(id) {
            let self = this
            let data = {}
              data.docs_id = id;
              this.$store
                .dispatch("campaignsManagement/deleteDocsOpportunity", data)
                .then(res => {
                    if (res.data.status == 'success') {
                        self. showOpportunityDocs()
                        this.$vs.notify({
                            color: "success",
                            title: "Delete Opportunity Document",
                            text: "Opportunity Document has been deleted successfully"
                        });
                    }
                })
                .catch(err => {
                  console.log(err)
                })

        
    //   this.$store.dispatch("dataList/removeItem", id).catch(err => { console.error(err) })
    },
        downloadOpportunityDocs() {
            let self = this

            let data = {}

            if (self.opportunity_docs_lists.length == 0) {

                self.$vs.notify({
                    color: "danger",
                    title: "Alert Document",
                    text: "No documents available to downloand: There are no alerts available to download for this campaign currently "
                });
                return false

            }

            if (self.selected_opportunity_docs.length == 0) {

                self.$vs.notify({
                    color: "danger",
                    title: "Alert Document",
                    text: "Please select one or more alerts to download"
                });
                return false

            }
            data.selected_opportunity_docs = self.selected_opportunity_docs

            console.log(data.selected_opportunity_docs)
            self.$store
                .dispatch("campaignsManagement/downloadOpportunityDocs", data)
                .then(res => {
                    let response = res.data
                    if (response) {
                        let fileName = 'alert_document.pdf'
                        if (data.selected_opportunity_docs.length <= 1) {
                            if (self.selected_opportunity_docs.length != 0) {
                                fileName = self.selected_opportunity_docs[0].name
                            }
                            var blob = new Blob([response], {
                                type: "application/pdf"
                            });
                            saveAs(blob, fileName);
                        } else {
                            fileName = `docs.zip`
                            var blob = new Blob([response], {
                                type: "application/octet-stream"
                            });
                            saveAs(blob, fileName);
                        }

                    }
                })
                .catch(err => {
                    console.log(err)
                    if (err.response.status === 401) {
                        this.$router.replace("/login");
                    }
                })

        },
        checkClientUserCampaignPermission() {

            // if (this.user_role == 'Client' && this.user_role == 'Client Administrator') {

            //   let data = {}
            //   data.campaign_id = this.$route.params.campaignId;
            //   data.user_id = this.user_id;
            //   this.$store
            //     .dispatch("campaignsManagement/checkClientUserCampaignPermission", data)
            //     .then(res => {
            //       let result = JSON.parse(res.data)
            //       if (result.length == 0) {
            //         this.authorized = false
            //         this.$router.replace("/unauthorized")
            //       }
            //     })
            //     .catch(err => {
            //       if (err.response.status === 401) {
            //         this.$router.replace("/login");
            //       }
            //     })

            // }

            if (this.user_role == 'Sales Developer') {
                this.authorized = false
                this.$router.replace("/unauthorized")
            }

        },
         fetchSdAllocationSummary() {
            // Internal-only content. NOTE: this page's old client-permission
            // check is commented out in the baseline, so gate by role here —
            // Client / Client Administrator get no allocation data at all.
            // (Sales Developer role is already barred from the whole page.)
            if (this.user_role == 'Client' || this.user_role == 'Client Administrator') return;
            var self = this;
            this.$store
                .dispatch("campaignsManagement/getSdAllocationSummary", this.$route.params.campaignId)
                .then(res => {
                    // response nests under data.data: {status, data:{...}}, 201
                    self.sd_allocation_summary = res.data && res.data.data ? res.data.data : null;
                })
                .catch(err => {
                    if (err.response && err.response.status === 401) {
                        this.$router.replace("/login");
                    }
                });
        },

        opportunityDocsSetPaginate: function (i) {
            if (this.opportunity_docs_current == 1) {
                return i < this.opportunity_docs_paginate;
            } else {
                return (i >= (this.opportunity_docs_paginate * (this.opportunity_docs_current - 1)) && i < (this.opportunity_docs_current * this.opportunity_docs_paginate));
            }
        },
        opportunityDocsUpdateCurrent: function (i) {
            this.opportunity_docs_current = i;
        },
        opportunityDocsUpdatePaginate: function () {
            this.opportunity_docs_current = 1;
            this.opportunity_docs_paginate_total = Math.ceil(document.querySelectorAll(".all_opportunity_docs_rows").length / this.opportunity_docs_paginate);
        },
        showOpportunityDocs() {
            let self = this
            let campaign_id = this.$route.params.campaignId;
            this.$store.dispatch("campaignsManagement/getCampaignOpportunityDocsLists", campaign_id)
                .then(res => {
                    let result = res.data
                    this.opportunity_docs_lists = result
                    self.opportunity_docs_paginate_total = Math.ceil(self.opportunity_docs_lists.length / self.opportunity_docs_paginate);

                    self.showOpportunityDocsPopup = true

                })
                .catch(err => {
                    console.log(err);

                    if (err.response.status === 401) {
                        this.$router.replace("/login");
                    }
                });

        },
        forceFileDownload(response, title) {
            console.log(title);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", title);
            document.body.appendChild(link);
            link.click();
        },
        downloadBriefingWithAxios(filename) {
            axios
                .get(`/api/campaigns/download_briefing_upload/${filename}`, {
                    responseType: 'blob',
                })
                .then(response => {
                    this.forceFileDownload(response, filename);
                })
                .catch(error => {
                    reject(error);
                });
        },
        downloadEOCRWithAxios(filename) {
            axios
                .get(`/api/campaigns/download_eocr_upload/${filename}`, {
                    responseType: 'blob',
                })
                .then(response => {
                    this.forceFileDownload(response, filename);
                })
                .catch(error => {
                    reject(error);
                });
        },
        init() {
            const campaignId = this.$route.params.campaignId;
            this.$store
                .dispatch("campaignsManagement/fetchCampaign", campaignId)
                .then(res => {
                    this.campaignDescription = res.data;

                    console.log(this.campaignDescription)

                    if (this.campaignDescription.campaign_status) {
                        this.showCampaignStatus(this.campaignDescription.campaign_status);
                    }
                    let client_campaign_association = this.campaignDescription
                        .client_campaign_association;

                    let self = this;
                    this.campaignDescription.client_campaign_association = this.campaignDescription.client_campaign_association.filter(
                        function (e) {
                            //check primary client
                            let data = {};
                            data.campaignId = self.$route.params.campaignId;
                            data.clientId = e.id;

                            self.$store
                                .dispatch("campaignsManagement/checkCampaignPrimaryClient", {
                                    data
                                })
                                .then(res => {
                                    if (res.data) {
                                        let result = JSON.parse(res.data);

                                        if (result.length != 0) {

                                            self.primary_client = result[0].client_id;

                                        }
                                    }
                                })
                                .catch(err => {});
                        }
                    );

                    let user_campaign_association = this.campaignDescription
                        .user_campaign_association;

                    let merge_clients_primary_contacts = client_campaign_association.map(
                        (item, i) => Object.assign({}, item, user_campaign_association[i])
                    );

                    let newArray = [];

                    merge_clients_primary_contacts = merge_clients_primary_contacts.filter(
                        function (item, index) {
                            let newObj = {};
                            newObj.counter = index;
                            newObj.client_id = item.client_id;
                            newObj.primary_contact_id = item.id;
                            newObj.client_name = item.company_name;
                            newObj.primary_contact_name =
                                item.first_name + " " + item.surname;
                            newArray.push(newObj);
                        }
                    );
                    this.campaignDescription.clients = newArray;

                    let all_associated_users = this.campaignDescription.user_campaign_association

                    this.campaignDescription.user_campaign_association = all_associated_users.filter(
                        function (ele) {
                            return ele.is_client == "n";
                        }
                    );

                    this.campaignDescription.other_client_user_campaign_association = all_associated_users.filter(
                        function (ele) {
                            return ele.is_client == "y";
                        }
                    );

                    console.log("USER", this.campaignDescription.other_client_user_campaign_association)

                    if (this.campaignDescription.campaign_manager) {
                        this.getCampaignManager(this.campaignDescription.campaign_manager);
                    }
                 
                })
                .catch(err => {
                    console.log(err)
                    if (err.response.status === 401) {
                        this.$router.replace("/login");
                    }
                })
        },
        getCampaignManager(managerUserId) {
            this.$store
                .dispatch("elomarkUsersManagement/fetchElomarkUser", managerUserId)
                .then(res => {
                    if (res) {
                        this.campaignManager = res.data.first_name + " " + res.data.surname;
                    }
                })
                .catch(err => {
                    if (err.response.status === 401) {
                        this.$router.replace("/login");
                    }
                })
        },
        getSalesDeveloper1(managerUserId) {
            this.$store
                .dispatch("elomarkUsersManagement/fetchElomarkUser", managerUserId)
                .then(res => {
                    if (res) {
                        this.salesDeveloper1 = res.data.first_name + " " + res.data.surname;
                    }
                })
                .catch(err => {
                    if (err.response.status === 401) {
                        this.$router.replace("/login");
                    }
                })
        },
        getSalesDeveloper2(managerUserId) {
            this.$store
                .dispatch("elomarkUsersManagement/fetchElomarkUser", managerUserId)
                .then(res => {
                    if (res) {
                        this.salesDeveloper2 = res.data.first_name + " " + res.data.surname;
                    }
                })
                .catch(err => {
                    if (err.response.status === 401) {
                        this.$router.replace("/login");
                    }
                })
        },
        getSalesDeveloper3(managerUserId) {
            this.$store
                .dispatch("elomarkUsersManagement/fetchElomarkUser", managerUserId)
                .then(res => {
                    if (res) {
                        this.salesDeveloper3 = res.data.first_name + " " + res.data.surname;
                    }
                })
                .catch(err => {
                    if (err.response.status === 401) {
                        this.$router.replace("/login");
                    }
                })
        },
        getClientManager(managerUserId) {
            this.$store
                .dispatch("clientUsersManagement/fetchClientUser", managerUserId)
                .then(res => {
                    if (res) {
                        this.prevClientContact =
                            res.data.first_name + " " + res.data.surname;
                    }
                })
                .catch(err => {
                    if (err.response.status === 401) {
                        this.$router.replace("/login");
                    }
                })
        },
        showCampaignStatus(statusId) {
            this.$store
                .dispatch("campaignsManagement/fetchStatus", statusId)
                .then(res => {
                    if (res) {
                        let response = res.data;
                        this.campaignStatus = response.campaign_status;
                    }
                })
                .catch(err => {
                    if (err.response.status === 401) {
                        this.$router.replace("/login");
                    }
                })
        },
        showClientName(clientId) {
            this.$store
                .dispatch("clientsManagement/fetchClient", clientId)
                .then(res => {
                    if (res) {
                        let response = res.data;
                        this.clientName = response.company_name;
                    }
                })
                .catch(err => {
                    if (err.response.status === 401) {
                        this.$router.replace("/login");
                    }
                })
        },
        goBack: function () {
            this.$router
                .push("/campaigns")
                .catch(() => {});
        },
        editCompany() {
            // this.$router.replace("edit/" + this.campaignDescription.id);
            let campaignId = this.campaignDescription.id;
            this.$router.push({
                path: `edit/${campaignId}`
            });
        },
        convertTime(apiTime) {
            // date = Date.parse(apiTime)
            let date = new Date(apiTime);
            return date.toLocaleString();
        }
    }
};
</script>

<style scoped>
.con-vs-popup .vs-popup {
    width: 900px !important;
}

.item.expanded {
    color: black !important;
    background-color: none !important;
}

.vs-icon-bg.bg-small {
    width: 2.5rem;
    height: 2.5rem;
    border: 1px solid red;
    margin: 0px 20px;
    cursor: pointer;
}

.inputx {
    width: 50px;
}

.vs-table--tbody-table tr {
    -webkit-transition: none;
    transition: none;
    background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
    -webkit-transform: none;
    transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
    padding: 25px 15px;
    font-weight: 600;
    font-size: 14px;
}

.pagination {
    display: inline-block;
}

.pagination a {
    color: black;
    float: left;
    padding: 8px 16px;
    text-decoration: none;
    border: 1px solid #ddd;
    /* Gray */
}

/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
